export default __webpack_public_path__ + "static/media/1101.d8e1989a.png";